export default __webpack_public_path__ + "static/media/E3.0a0e5b51.mp3";